import React from "react";

import { EntryDateClassificationContainer } from "../../../containers";

const EntryDateClassification = (props) => {
  return <EntryDateClassificationContainer {...props} />;
};

export default EntryDateClassification;
